(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function init() {
    document.querySelectorAll('[data-pcp-description]:not([data-organized])').forEach(body => {
      body.dataset.organized = 'true';
      const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
      const originalNodes = [];
      while (walker.nextNode()) originalNodes.push([walker.currentNode, walker.currentNode.textContent]);
      const content = body.children.length === 1 && body.firstElementChild.matches('.rte, section') ? body.firstElementChild : body;
      const nodes = [...content.childNodes];
      if (!nodes.some(n => n.nodeType === 1 && n.matches('h2,h3'))) { body.dataset.contentPreserved = 'true'; return; }
      const groups = document.createDocumentFragment();
      let section;
      const make = title => {
        const d = document.createElement('details'); d.className = 'pcp-pdp-detail';
        const s = document.createElement('summary'); s.textContent = title; d.append(s);
        const panel = document.createElement('div'); panel.className = 'pcp-pdp-detail-body'; d.append(panel); groups.append(d); return panel;
      };
      for (const node of nodes) {
        if (node.nodeType === 1 && node.matches('h2,h3')) {
          section = make(node.textContent); node.classList.add('visually-hidden'); section.append(node);
        } else {
          if (!section) section = make(body.dataset.intro);
          section.append(node);
        }
      }
      content.append(groups);
      // Content is moved, never discarded; descriptions remain available to search and assistive technology.
      body.dataset.contentPreserved = String(originalNodes.every(([node, text]) => body.contains(node) && node.textContent === text));
    });
    document.querySelectorAll('[data-pcp-product-gallery]:not([data-autoplay-ready])').forEach(async gallery => {
      gallery.dataset.autoplayReady = 'true';
      await customElements.whenDefined('slideshow-component');
      const slider = gallery.querySelector('slideshow-component');
      const button = gallery.querySelector('[data-pcp-gallery-play]');
      if (!slider || !button) return;
      const interval = Math.max(3000, Number(gallery.dataset.autoplayInterval) || 7000);
      let timer, paused = false, touching = false, visible = false;
      const stop = () => { clearTimeout(timer); timer = undefined; };
      const blocked = () => paused || reduced.matches || document.hidden || !visible || touching || gallery.matches(':hover') || (gallery.contains(document.activeElement) && document.activeElement !== button) || document.querySelector('zoom-dialog dialog[open]');
      const schedule = () => {
        stop(); if (blocked()) return;
        timer = setTimeout(() => { if (!blocked()) slider.next(); schedule(); }, interval);
      };
      const update = () => {
        button.hidden = reduced.matches;
        button.textContent = paused ? button.dataset.play : button.dataset.pause;
        button.setAttribute('aria-pressed', String(paused)); schedule();
      };
      button.addEventListener('click', () => { paused = !paused; update(); });
      gallery.addEventListener('pointerenter', stop);
      gallery.addEventListener('pointerleave', schedule);
      gallery.addEventListener('pointerdown', () => { touching = true; stop(); });
      window.addEventListener('pointerup', () => { touching = false; schedule(); });
      window.addEventListener('pointercancel', () => { touching = false; schedule(); });
      gallery.addEventListener('focusin', stop);
      gallery.addEventListener('focusout', () => requestAnimationFrame(schedule));
      gallery.addEventListener('click', schedule);
      gallery.addEventListener('slideshow:select', schedule);
      document.addEventListener('visibilitychange', schedule);
      reduced.addEventListener('change', update);
      new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: .25 }).observe(gallery);
      gallery.pcpAutoplay = { get interval() { return interval; }, get paused() { return paused; } };
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
